/* eslint-disable radix */
/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import MaxLengthNumericEditor from '../../../../SharedModules/CustomAgGridEditor/inputComponent';
import * as Styles from '../../../../SharedModules/StyleConstant/StyleConstant';
import { numberAndTextComparator } from '../../client/Components/gridComponents/tableHead';

function monthToComparableNumber(date) {
  if (date === undefined || date === null || date.length !== 10) {
    return null;
  }

  const yearNumber = Number.parseInt(date.substring(6, 10));
  const monthNumber = Number.parseInt(date.substring(3, 5));
  const dayNumber = Number.parseInt(date.substring(0, 2));

  return yearNumber * 10000 + monthNumber * 100 + dayNumber;
}

export const PARTICPATION_DATES = [
  {
    headerName: 'Actions',
    field: 'corrLinkId',
    filter: false,
    sortable: false,
    resizable: false,
    showCheckboxIcon: true,
    minWidth: Styles.Width_100,
    editable: false,
    suppressMenu: false,
    valueFormatter: (params) => {
      return params.data.corrLinkId ? 1 : 0;
    },
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'DeleteBoxRender',
    exportOption: {
      enableValueFormatter: true,
    },
    cellStyle: { 'border-right-color': Styles.BorderColor },
  },
  {
    headerName: 'Start Date',
    field: 'startDt',
    editable: false,
    cellRenderer: 'StartDate',
    filter: 'agTextColumnFilter',
    minWidth: 160,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Width_200,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    sortingOrder: ['asc'],
  },
  {
    headerName: 'End Date',
    field: 'endDt',
    editable: false,
    cellRenderer: 'EndDate',
    filter: 'agTextColumnFilter',
    minWidth: 160,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Width_200,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Group Name',
    field: 'groupName',
    filter: 'agTextColumnFilter',
    cellRenderer: 'GroupNameCustomComponent',
    minWidth: 160,
    cellEditor: MaxLengthNumericEditor,
    editable: false,
    maxLength: Styles.Length_255,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const MAINTAIN_GROUP_PLANS = [
  {
    headerName: 'Plan ID',
    field: 'cgpId.planId',
    comparator: numberAndTextComparator,
    cellRenderer: 'CustomNavigationComponent',
    editable: false,
    minWidth: 100,
    cellStyle: {
      borderRightColor: '#D6D2D0',
      display: 'flex',
      alignItems: 'center',
    },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    sortingOrder: ['desc', 'asc'],
  },
  {
    headerName: 'Start Date',
    field: 'cgpId.startDt',
    cellRenderer: 'dateRenderComponent',
    editable: false,
    minWidth: 160,
    maxLength: Styles.Width_200,
    cellStyle: {
      'border-right-color': Styles.BorderColor,
      display: 'flex',
      alignItems: 'center',
    },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'End Date',
    field: 'endDt',
    cellRenderer: 'dateRenderComponent',
    editable: false,
    minWidth: 160,
    maxLength: Styles.Width_200,
    cellStyle: {
      'border-right-color': Styles.BorderColor,
      display: 'flex',
      alignItems: 'center',
    },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Plan Name',
    cellRenderer: 'planNameRender',
    field: 'planName',
    editable: false,
    minWidth: 160,
    maxLength: Styles.Length_255,
    cellStyle: { display: 'flex', alignItems: 'center' },
    sortingOrder: ['desc', 'asc'],
    cellClass: 'frr-ellipsis-text',
    filter: 'agTextColumnFilter',
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Rebate Program',
    field: 'rebateProgramCd',
    editable: false,
    resizable: false,
    minWidth: 160,
    maxLength: Styles.Length_255,
    cellStyle: { display: 'flex', alignItems: 'center' },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];
